import { t } from 'i18next'

export function mapClassificationData(data) {
    if (!Array.isArray(data)) return [];
  
    return data.map((el) => {
      const classificationCategoryLabel = (category) =>
        category.replace("CATEGORY_", "") + ") " + t(category);
  
      const classificationValueLabel = (value) => `${t(value)}(${value})`;
  
      const categoryTypes = el.suggestedInvoiceCategories.map((e) => ({
        value: e.classificationCategory,
        label: classificationCategoryLabel(e.classificationCategory),
        classificationValues: e.classificationValues,
      }));
  
      const classificationValues = el.classificationValues.map((value) => ({
        value,
        label: classificationValueLabel(value),
      }));
  
      return {
        id: el.id,
        classificationCategory: {
          value: el.classificationCategory,
          label: classificationCategoryLabel(el.classificationCategory),
        },
        classificationValue: {
          value: el.classificationValue,
          label: classificationValueLabel(el.classificationValue),
        },
        invoiceType: {
          value: el.invoiceType.id,
          label: el.invoiceType.name,
          myDataInvoiceType: el.invoiceType.myDataInvoiceType,
        },
        classificationCategoryTypes: categoryTypes,
        classificationValues,
        selfPricing: el.selfPricing,
        percent: el.percent,
        amount: el.amount,
      };
    });
  }
